export default import.meta.ROLLDOWN_FILE_URL_Pfiv8SoUfQMa_7dTVCKlpQ